import gql from 'graphql-tag';

export const DESTROY_PURCHASE_ORDER_ITEM = gql`
	mutation PurchaseOrderItemMutation($id: ID!) {
		destroyPurchaseOrderItem(id: $id) 
	}
`;
